import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de698b5c6a30cb/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de698b5c6a30cb/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de698b5c6a30cb/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de698b5c6a30cb/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de698b5c6a30cb/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/node_modules/next/dist/client/link.js");
